import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import { clearCharacter } from '../../actions/character';

import logoImg from '../../img/logo_K.png'

const Footer = () => {

    return (
        <div className='footer'>Copyright 2024 &#169; Nick Classen</div>
    )
}

Footer.propTypes = {
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(Footer);
